/**
 * TGH Senior Center — FAQ accordion
 * Progressive enhancement: answers are visible without JS; once ready the
 * section gets .is-ready and closed items collapse (CSS grid 0fr → 1fr).
 * Options on [data-tgh-accordion]: data-single="true" → only one item open.
 */
(function () {
  'use strict';

  function init() {
    document.querySelectorAll('[data-tgh-accordion]').forEach(function (list) {
      if (list.dataset.tghReady) return;
      list.dataset.tghReady = '1';

      var single = list.getAttribute('data-single') === 'true';
      var items = Array.prototype.slice.call(list.querySelectorAll('.tgh-faq__item'));
      var toggles = items.map(function (item) { return item.querySelector('.tgh-faq__toggle'); });

      function setOpen(item, open) {
        var toggle = item.querySelector('.tgh-faq__toggle');
        item.classList.toggle('tgh-faq__item--open', open);
        toggle.setAttribute('aria-expanded', String(open));
      }

      items.forEach(function (item, index) {
        var toggle = toggles[index];
        if (!toggle) return;

        toggle.addEventListener('click', function () {
          var open = toggle.getAttribute('aria-expanded') !== 'true';
          if (single && open) items.forEach(function (other) { if (other !== item) setOpen(other, false); });
          setOpen(item, open);
        });

        // WAI-ARIA accordion keyboard pattern
        toggle.addEventListener('keydown', function (event) {
          var target = null;
          if (event.key === 'ArrowDown') target = toggles[(index + 1) % toggles.length];
          if (event.key === 'ArrowUp') target = toggles[(index - 1 + toggles.length) % toggles.length];
          if (event.key === 'Home') target = toggles[0];
          if (event.key === 'End') target = toggles[toggles.length - 1];
          if (target) { event.preventDefault(); target.focus(); }
        });
      });

      // Deep link: #tgh-faq-a3 opens that answer
      var hash = window.location.hash && document.getElementById(window.location.hash.slice(1));
      if (hash && list.contains(hash)) {
        var owner = hash.closest('.tgh-faq__item');
        if (owner) setOpen(owner, true);
      }

      var section = list.closest('.tgh-faq');
      (section || list).classList.add('is-ready');
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();



// WEBPACK FOOTER //
// ./assets/js/modules/accordion.js